import {
  Component,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import * as deepEqual from 'deep-equal';

import { ValuePair } from '../../../../interfaces/ValuePair';
import { BaseSelectComponent } from '../../base-select.component';
import { BaseSelect } from '../../base-select.interface';

@Component({
  selector: 'ls-single-select',
  templateUrl: './ls-single-select.component.html',
  styleUrls: ['./ls-single-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LsSingleSelectComponent),
      multi: true
    }
  ]
})
export class LsSingleSelectComponent extends BaseSelectComponent
  implements BaseSelect, OnInit, OnChanges {
  @Input()
  public lsSingleSelectFormControl: FormControl;
  @Input()
  public label: string;
  public required = false;
  public selectedData: string;

  private _activeItem: string;
  private _selectedName: string;

  public get activeItem(): string {
    return this._activeItem;
  }

  @Input('activeItem')
  public set activeItem(value: string) {
    if (!value || this._activeItem === value) {
      return;
    }
    const foundItem: ValuePair = this.items.find((item: ValuePair) =>
      deepEqual(item.value, value)
    );
    this.select(foundItem || { name: '', value: '' });
    this._activeItem = value;
  }

  constructor() {
    super();
  }

  public ngOnInit(): void {
    if (this._activeItem) {
      const foundItem: ValuePair = this.items.find(
        (item: ValuePair) => item.value === this._activeItem
      );
      if (foundItem) {
        this.select(foundItem);
      }
    }

    if (
      this.lsSingleSelectFormControl &&
      this.lsSingleSelectFormControl.validator
    ) {
      this.required = this.lsSingleSelectFormControl.validator(
        {} as AbstractControl
      ).required;
    }

    this.disabled = this.lsSingleSelectFormControl
      ? this.lsSingleSelectFormControl.disabled
      : false;
  }

  public ngOnChanges(simpleChanges: SimpleChanges): void {
    if (this._activeItem && simpleChanges.items) {
      let foundValuePair: ValuePair = simpleChanges.items.currentValue.find(
        (item: ValuePair) => {
          return item.value.toString() === this._activeItem.toString();
        }
      );

      foundValuePair = foundValuePair
        ? foundValuePair
        : { name: '', value: '' };
      this.select(foundValuePair);
    }

    this.disabled = this.lsSingleSelectFormControl
      ? this.lsSingleSelectFormControl.disabled
      : false;
  }

  public writeValue(value: any): void {
    this.activeItem = value;
  }

  public select(item: ValuePair, event?: MouseEvent): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (item && item.value === this.selectedData) {
      return;
    }

    this.selectedData = item.value;
    this._selectedName = item.name;
    this.propagateChange(item.value);
  }

  public selectAndClose(item: ValuePair, event?: MouseEvent): void {
    this.toggle(event);
    this.select(item, event);
  }

  public isSelected(item: ValuePair): boolean {
    return this.selectedData === item.value;
  }

  public get selectedName(): string {
    if (!this._selectedName && this.items) {
      const valuePair: ValuePair = this.items.find(
        (valPair: ValuePair) => valPair.value === this.selectedData
      );
      if (valuePair) {
        return valuePair.name;
      }
    } else {
      return this._selectedName;
    }
  }

  public setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }
}
